module.exports = __webpack_public_path__ + "static/media/graduate_icon.41b28a77.svg";